module.exports = __webpack_public_path__ + "static/media/Male_Low.ee0e494a.svg";